import { Input, InputAdornment } from "@material-ui/core";
import { debounce } from "lodash";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";

type Props = {
    placeholder?: string;
    searchValue?: string;
    style?: React.CSSProperties;
    debounceMs?: number;
    onChange: (value: string) => void;
    onFocus?: () => void;
};

export const SearchField = ({ placeholder, searchValue, style, debounceMs, onChange, onFocus }: Props) => {
    const [value, setValue] = React.useState(searchValue ?? "");

    // Optional debounce
    const onSearchChanged = React.useMemo(
        () =>
            debounceMs
                ? debounce((value: string) => {
                      onChange(value);
                  }, debounceMs)
                : onChange,
        [debounceMs, onChange]
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        onSearchChanged(event.target.value);
    };

    const handleReset = () => {
        setValue("");
        onChange("");
    };

    return (
        <Input
            onChange={handleChange}
            onFocus={onFocus}
            placeholder={placeholder}
            autoComplete="off"
            value={value}
            endAdornment={
                value ? (
                    <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleReset}>
                        <img src={THEME.Images.icClose} alt="" />
                    </InputAdornment>
                ) : (
                    <InputAdornment position="end">
                        <img src={THEME.Images.icSearch} alt="" />
                    </InputAdornment>
                )
            }
            inputProps={{ style: { fontSize: 12, color: THEME.customColors.body1Dark } }}
            style={{
                height: 40,
                borderRadius: "100px",
                padding: "0 18px",
                maxWidth: 320,
                border: `1px solid ${THEME.customColors.dataUploadBorderColor}`,
                ...style
            }}
            disableUnderline={true}
        />
    );
};
